import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { PageTitles, PurchaseFlowSteps } from '../../common/enums/purchaseFlow';
import { PurchaseFlowService } from '../../services/purchase-flow.service';
import { StepChange } from '../../common/types/purchaseFlow';
import { PopupsManagerService } from '../../services/popups-manager.service';
import { BasePopupComponent } from '../../common/base/base-popup.component';
import { Events } from '../wall/events';
import { EventKey } from '../../common/enums/event-key';
import { ComplexWallItem } from '../../common/types/wall-item';
import { Router } from '@angular/router';

@Component({
  selector: 'app-purchase-flow',
  templateUrl: './purchase-flow.component.html',
  styleUrls: ['./purchase-flow.component.scss'],
})
export class PurchaseFlowComponent
  extends BasePopupComponent
  implements OnInit, OnDestroy
{
  @Input() currentStep: PurchaseFlowSteps = PurchaseFlowSteps.Tile;
  @Input() wallItem: ComplexWallItem | undefined;
  @Input() isCartItem: boolean | undefined;

  public tilesSize!: number;
  public PurchaseFlowSteps = PurchaseFlowSteps;
  public steps: string[] | undefined;
  public pageTitle: string[] = PageTitles;
  public loading: boolean = false;

  constructor(
    public purchaseFlowService: PurchaseFlowService,
    public popupsManagerService: PopupsManagerService,
    private router: Router
  ) {
    super(popupsManagerService);
  }

  ngOnInit(): void {
    this.steps = Object.keys(PurchaseFlowSteps).filter(
      (step: any) =>
        isNaN(step) && step !== PurchaseFlowSteps[PurchaseFlowSteps.EditImage]
    );
    this.purchaseFlowService.stepChange$
      .pipe(
        takeUntil(this.destroy$),
        takeWhile(() => this.currentStep !== PurchaseFlowSteps.EditImage)
      )
      .subscribe(
        (stepChange: StepChange) => (this.currentStep = stepChange.step)
      );
    this.purchaseFlowService.addingToCart$
      .pipe(takeUntil(this.destroy$))
      .subscribe((loading: boolean) => (this.loading = loading));
  }

  public nextStep(): void {
    if (this.currentStep === PurchaseFlowSteps.EditImage) {
      this.purchaseFlowService.editCartItem(this.wallItem!, () => {
        if (this.isCartItem) {
          this.router.navigateByUrl('/cart');
        }
      });
    } else {
      this.purchaseFlowService.nextStep();
    }
  }

  public previousStep(): void {
    this.purchaseFlowService.previousStep();
  }

  public closePopup() {
    if (this.loading) {
      return;
    }
    Events.emit({ key: EventKey.RemovePreviewImage });
    super.closePopup();
  }

  public imageSelectHandler(tokenId: string) {
    this.purchaseFlowService.selectedAssetChange(tokenId);
  }

  ngOnDestroy() {
    this.purchaseFlowService.resetValues();
    super.ngOnDestroy();
  }
}
